import { EntityBase } from './entity-base';

/**
 * Represents a Team entity for team management.
 * Teams are used to group users and assign business process rights.
 */
export class TeamEntity extends EntityBase {
  /**
   * Indicates whether this team can be deleted.
   * When false or null, the team is protected and cannot be deleted (e.g., system teams).
   * @type {boolean}
   * @default false
   */
  public isDeletable: boolean = false;

  /**
   * Number of users currently assigned to this team.
   * This is a computed property from the backend.
   * @type {number}
   * @default 0
   */
  public userCount: number = 0;

  /**
   * Creates a new instance of TeamEntity.
   * @param data Optional partial data to initialize the entity
   */
  constructor(data?: Partial<TeamEntity>) {
    super();
    if (data) {
      Object.assign(this, data);
    }
  }

  /**
   * Checks if this team is a system/protected team.
   * @returns {boolean} True if team is protected from deletion
   */
  public isSystemTeam(): boolean {
    return !this.isDeletable;
  }

  /**
   * Checks if this team can be deleted.
   * @returns {boolean} True if team can be deleted
   */
  public canBeDeleted(): boolean {
    return this.isDeletable && this.userCount === 0;
  }
}
